import _pick from 'lodash/pick';

/**
 * Merge the customized feature flipping to the one from the config
 * and remove the extra customized feature flipping keys that are not defined in the config.
 *
 * Set banned features to false.
 *
 * @param {Array} configuredBannedFeatures
 * @param {Object} configuredFeatureFlipping
 * @param {Object} [customizedFeatureFlipping]
 * @returns
 */
export const getFeatureFlipping = (
  configuredBannedFeatures,
  configuredFeatureFlipping,
  customizedFeatureFlipping = {},
) => {
  if (!configuredBannedFeatures) {
    throw new Error('Missing banned features from config');
  }
  if (!configuredFeatureFlipping) {
    throw new Error('Missing feature flipping from config');
  }

  const featureFlippingWithCustomization = {
    ...configuredFeatureFlipping,
    ..._pick(customizedFeatureFlipping, Object.keys(configuredFeatureFlipping)),
  };

  return Object.entries(featureFlippingWithCustomization).reduce(
    (memo, [key, value]) => ({ ...memo, [key]: configuredBannedFeatures.includes(key) ? false : value }),
    {},
  );
};
